export default "__VITE_ASSET__CfglfOTb__"